var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13683",
    "data-name": "Group 13683",
    transform: "translate(-1138 -853)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(1138 853)",
    fill: "#f3f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "angle-down-solid_1_",
    "data-name": "angle-down-solid (1)",
    d: "M40.937,171.341a1.7,1.7,0,0,0,2.409,0l8.509-8.509a1.7,1.7,0,0,0-2.409-2.409l-7.307,7.307-7.307-7.3a1.7,1.7,0,0,0-2.409,2.409l8.509,8.509Z",
    transform: "translate(1117.861 709.118)",
    fill: "#686868"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsMenuIcon);
export default __webpack_public_path__ + "static/media/options-menu-icon.03cbf0ce33c1ff317e4c949475a1ed17.svg";
export { ForwardRef as ReactComponent };